/**
 * DashboardShared — Shared types, constants, and styles for the contract
 * dashboards (ContractDashboard + its ability-contract checks).
 */

// ── Types ───────────────────────────────────────────────

export type Status = 'pass' | 'fail' | 'warn';

export interface Check {
  id: string;
  label: string;
  status: Status;
  detail: string;
}

// ── Styles ──────────────────────────────────────────────

export const statusColors: Record<Status, string> = {
  pass: '#2ecc71',
  fail: '#e74c3c',
  warn: '#f39c12',
};

export const statusIcons: Record<Status, string> = {
  pass: '\u2713',
  fail: '\u2717',
  warn: '~',
};
